import script from "./SecondWebsiteDiscountBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondWebsiteDiscountBanner.vue?vue&type=script&setup=true&lang=js"

import "./SecondWebsiteDiscountBanner.vue?vue&type=style&index=0&id=61878de8&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61878de8"]])

export default __exports__